import Api from "../../apiService";

class TelemetryDailyStatsApi {
  calendar(companyId, trackerId, params) {
    return Api.getRequest(
      `companies/${companyId}/telemetry/trackers/${trackerId}/daily_stats/calendar`,
      params,
      Api.authHeaders
    );
  }

  positions(companyId, params) {
    return Api.getRequest(
      `companies/${companyId}/telemetry/dashboard/route_report`,
      params,
      Api.authHeaders()
    );
  }
}

export default new TelemetryDailyStatsApi();
